import { createPostMutation, createPatchMutation, type BaseMutationInput } from "./mutation-factory";

interface CreateQueryInput extends BaseMutationInput {
  productId: string;
  requestId: string;
  question: string;
}

export const createQuery = createPostMutation<
  CreateQueryInput,
  { id: string; question: string; answer: string | null }
>(
  (input) => `/products/${input.productId}/requests/${input.requestId}/queries`,
  (input) => ({
    question: input.question,
  })
);

interface DislikeQueryInput extends BaseMutationInput {
  productId: string;
  requestId: string;
  queryId: string;
  isDisliked: boolean;
  dislikeComment?: string;
}

export const dislikeQuery = createPatchMutation<DislikeQueryInput, { id: string }>(
  (input) => `/products/${input.productId}/requests/${input.requestId}/queries/${input.queryId}/dislike`,
  (input) => ({
    isDisliked: input.isDisliked,
    dislikeComment: input.dislikeComment,
  })
);
